import { Spinner } from "@chakra-ui/react";
import React from "react";

function SpinnerLoad() {
  return (
    <div>
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10">
          <Spinner size="lg" color="blue.500" />
        </div>
    </div>
  );
}

export default SpinnerLoad;
